import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 告警
 */
const event = {
  /**
   * 设置告警通知等级重命名
   */
  setEventNotifyLevelRedefines(companyId, names) {
    return axios.post(
      base.event.setEventNotifyLevelRedefines,
      utils.postParamsArrayToJsonString({ companyId, names })
    );
  },
  /**
   * 查询告警通知等级重命名
   */
  getEventNotifyLevelRedefines(companyId) {
    return axios.post(
      base.event.getEventNotifyLevelRedefines,
      utils.postParamsArrayToJsonString({ companyId })
    );
  },
  /**
   * 个人查询告警通知等级重命名
   */
  getPersonalEventNotifyLevelRedefines(companyId) {
    return axios.post(
      base.event.getPersonalEventNotifyLevelRedefines,
      utils.postParamsArrayToJsonString({ companyId })
    );
  },
  /**
   * 增加告警类型
   */
  addEventType(name, displayName) {
    return axios.post(
      base.event.addEventType,
      utils.postParamsArrayToJsonString({ name, displayName })
    );
  },
  /**
   * 修改告警类型
   */
  modifyEventType(id, name, displayName) {
    return axios.post(
      base.event.modifyEventType,
      utils.postParamsArrayToJsonString({ id, name, displayName })
    );
  },
  /**
   * 删除告警类型
   */
  deleteEventType(id) {
    return axios.post(
      base.event.deleteEventType,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 查询告警类型
   */
  getEventTypes() {
    return axios.post(
      base.event.getEventTypes,
      utils.postParamsArrayToJsonString({})
    );
  },
  /**
   * 增加告警探测规则模板
   */
  addEventDetectRegulationTemplate(name) {
    return axios.post(
      base.event.addEventDetectRegulationTemplate,
      utils.postParamsArrayToJsonString({ name })
    );
  },
  /**
   * 修改告警探测规则模板
   */
  modifyEventDetectRegulationTemplate(id, name, displayName) {
    return axios.post(
      base.event.modifyEventDetectRegulationTemplate,
      utils.postParamsArrayToJsonString({ id, name, displayName })
    );
  },
  /**
   * 删除告警探测规则模板
   */
  deleteEventDetectRegulationTemplate(id) {
    return axios.post(
      base.event.deleteEventDetectRegulationTemplate,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 查询告告警探测规则模板
   */
  getEventDetectRegulationTemplates() {
    return axios.post(
      base.event.getEventDetectRegulationTemplates,
      utils.postParamsArrayToJsonString({})
    );
  },
  /**
   * 增加告警探测规则模板项
   */
  addEventDetectRegulationTemplateItem(
    templateId,
    name,
    displayName,
    code,
    type,
    level,
    mode,
    params,
    detectingByPhysicalDevice
  ) {
    return axios.post(
      base.event.addEventDetectRegulationTemplateItem,
      utils.postParamsArrayToJsonString({
        templateId,
        name,
        displayName,
        code,
        type,
        level,
        mode,
        params,
        detectingByPhysicalDevice,
      })
    );
  },
  /**
   * 修改告警探测规则模板项
   */
  modifyEventDetectRegulationTemplateItem(
    id,
    name,
    displayName,
    code,
    type,
    level,
    mode,
    params,
    detectingByPhysicalDevice
  ) {
    return axios.post(
      base.event.modifyEventDetectRegulationTemplateItem,
      utils.postParamsArrayToJsonString({
        id,
        name,
        displayName,
        code,
        type,
        level,
        mode,
        params,
        detectingByPhysicalDevice,
      })
    );
  },
  /**
   * 删除告警探测规则模板项
   */
  deleteEventDetectRegulationTemplateItem(id) {
    return axios.post(
      base.event.deleteEventDetectRegulationTemplateItem,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 查询告告警探测规则模板项
   */
  getEventDetectRegulationTemplateItems(templateId) {
    return axios.post(
      base.event.getEventDetectRegulationTemplateItems,
      utils.postParamsArrayToJsonString({ templateId })
    );
  },
  /**
   * 通过模板重置告警探测规则
   */
  resetEventDetectRegulationsViaTemplate(templateId, measuresId) {
    return axios.post(
      base.event.resetEventDetectRegulationsViaTemplate,
      utils.postParamsArrayToJsonString({ templateId, measuresId })
    );
  },
  /**
   * 增加告警探测规则
   */
  addEventDetectRegulation(
    name,
    displayName,
    measureId,
    code,
    type,
    mode,
    params,
    referenceTo,
    detectingByPhysicalDevice,
    enable,
    level
  ) {
    return axios.post(
      base.event.addEventDetectRegulation,
      utils.postParamsArrayToJsonString({
        name,
        displayName,
        measureId,
        code,
        type,
        mode,
        params,
        referenceTo,
        detectingByPhysicalDevice,
        enable,
        level,
      })
    );
  },
  /**
   * 修改告警探测规则
   */
  modifyEventDetectRegulation(
    id,
    name,
    displayName,
    type,
    mode,
    params,
    referenceTo,
    detectingByPhysicalDevice,
    enable,
    level
  ) {
    return axios.post(
      base.event.modifyEventDetectRegulation,
      utils.postParamsArrayToJsonString({
        id,
        name,
        displayName,
        type,
        mode,
        params,
        referenceTo,
        detectingByPhysicalDevice,
        enable,
        level,
      })
    );
  },
  /**
   * 删除告警探测规则
   */
  deleteEventDetectRegulation(id) {
    return axios.post(
      base.event.deleteEventDetectRegulation,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 查询告警探测规则
   */
  getEventDetectRegulations(measureId) {
    return axios.post(
      base.event.getEventDetectRegulations,
      utils.postParamsArrayToJsonString({ measureId })
    );
  },
  /**
   * 查询告警探测规则
   */
  getEventDetectRegulations2(regulationsId) {
    return axios.post(
      base.event.getEventDetectRegulations2,
      utils.postParamsArrayToJsonString({ regulationsId })
    );
  },
  /**
   * 增加告警通知规则
   */
  addEventNotifyRegulation(
    detectRegulationId,
    targetUserId,
    notifyingBy,
    level,
    enable
  ) {
    return axios.post(
      base.event.addEventNotifyRegulation,
      utils.postParamsArrayToJsonString({
        detectRegulationId,
        targetUserId,
        notifyingBy,
        level,
        enable,
      })
    );
  },
  /**
   * 增加告警通知规则
   */
  addEventNotifyRegulation2(
    detectRegulationsId,
    targetUserId,
    notifyingBy,
    level,
    enable
  ) {
    return axios.post(
      base.event.addEventNotifyRegulation2,
      utils.postParamsArrayToJsonString({
        detectRegulationsId,
        targetUserId,
        notifyingBy,
        level,
        enable,
      })
    );
  },
  /**
   * 修改告警通知规则
   */
  modifyEventNotifyRegulation(id, targetUserId, notifyingBy, level, enable) {
    return axios.post(
      base.event.modifyEventNotifyRegulation,
      utils.postParamsArrayToJsonString({
        id,
        targetUserId,
        notifyingBy,
        level,
        enable,
      })
    );
  },
  /**
   * 删除告警通知规则
   */
  deleteEventNotifyRegulation(id) {
    return axios.post(
      base.event.deleteEventNotifyRegulation,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 查询告警通知规则
   */
  getEventNotifyRegulations(detectRegulationId) {
    return axios.post(
      base.event.getEventNotifyRegulations,
      utils.postParamsArrayToJsonString({ detectRegulationId })
    );
  },
  /**
   * 查询告警/事件记录
   */
  getEventRecord(
    companyId,
    measuresId,
    codes,
    types,
    confirmingUserId,
    handlingUserId,
    levels,
    startTime,
    endTime,
    offset,
    limit
  ) {
    return axios.post(
      base.event.getEventRecord,
      utils.postParamsArrayToJsonString({
        companyId,
        measuresId,
        codes,
        types,
        confirmingUserId,
        handlingUserId,
        levels,
        startTime,
        endTime,
        offset,
        limit,
      })
    );
  },
  /**
   * 查询告警/事件记录
   */
  getCountOfEventRecord(
    companyId,
    measuresId,
    codes,
    types,
    confirmingUserId,
    handlingUserId,
    levels,
    startTime,
    endTime
  ) {
    return axios.post(
      base.event.getCountOfEventRecord,
      utils.postParamsArrayToJsonString({
        companyId,
        measuresId,
        codes,
        types,
        confirmingUserId,
        handlingUserId,
        levels,
        startTime,
        endTime,
      })
    );
  },
  /**
   * 处理告警/事件
   */
  handleEvent(eventId, comment) {
    return axios.post(
      base.event.handleEvent,
      utils.postParamsArrayToJsonString({ eventId, comment })
    );
  },
  /**
   * 查询告警处理表
   */
  getEventHandlingResult(eventId) {
    return axios.post(
      base.event.getEventHandlingResult,
      utils.postParamsArrayToJsonString({ eventId })
    );
  },
  /**
   * 确认告警/事件
   */
  confirmEvent(eventIds) {
    return axios.post(
      base.event.confirmEvent,
      utils.postParamsArrayToJsonString({ eventIds })
    );
  },
  /**
   * 查询告警处理表
   */
  getEventConfirmingResult(eventId) {
    return axios.post(
      base.event.getEventConfirmingResult,
      utils.postParamsArrayToJsonString({ eventId })
    );
  },
  /**
   * 查询告警计数概览
   */
  getOverviewThatCountOfEventHandling(companyId, startTime, endTime) {
    return axios.post(
      base.event.getOverviewThatCountOfEventHandling,
      utils.postParamsArrayToJsonString({ companyId, startTime, endTime })
    );
  },
  /**
   * 获取告警数量排行
   */
  getRankingThatCountOfEvent(companyId, startTime, endTime, limit) {
    return axios.post(
      base.event.getRankingThatCountOfEvent,
      utils.postParamsArrayToJsonString({
        companyId,
        startTime,
        endTime,
        limit,
      })
    );
  },
  /**
   * 获取告警数量排行
   */
  getRankingThatCountOfEvent2(measuresId, startTime, endTime) {
    return axios.post(
      base.event.getRankingThatCountOfEvent2,
      utils.postParamsArrayToJsonString({ measuresId, startTime, endTime })
    );
  },

  /**
   * 物业增加告警探测规则
   */
  addEventDetectRegulationForProperty(
    name,
    displayName,
    rentalAreaId,
    measureId,
    code,
    type,
    mode,
    params,
    referenceTo,
    detectingByPhysicalDevice,
    enable,
    companyId
  ) {
    return axios.post(
      base.event.addEventDetectRegulationForProperty,
      utils.postParamsArrayToJsonString({
        name,
        displayName,
        rentalAreaId,
        measureId,
        code,
        type,
        mode,
        params,
        referenceTo,
        detectingByPhysicalDevice,
        enable,
        companyId,
      })
    );
  },
  /**
   * 物业修改告警探测规则
   */
  modifyEventDetectRegulationForProperty(
    id,
    name,
    displayName,
    type,
    mode,
    params,
    referenceTo,
    detectingByPhysicalDevice,
    enable
  ) {
    return axios.post(
      base.event.modifyEventDetectRegulationForProperty,
      utils.postParamsArrayToJsonString({
        id,
        name,
        displayName,
        type,
        mode,
        params,
        referenceTo,
        detectingByPhysicalDevice,
        enable,
      })
    );
  },
  /**
   * 物业删除告警探测规则
   */
  deleteEventDetectRegulationForProperty(id) {
    return axios.post(
      base.event.deleteEventDetectRegulationForProperty,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 物业查询告警探测规则
   */
  getEventDetectRegulationsForProperty(measureId) {
    return axios.post(
      base.event.getEventDetectRegulationsForProperty,
      utils.postParamsArrayToJsonString({ measureId })
    );
  },
  /**
   * 物业查询告警探测规则
   */
  getEventDetectRegulationsForProperty2(regulationsId) {
    return axios.post(
      base.event.getEventDetectRegulationsForProperty2,
      utils.postParamsArrayToJsonString({ regulationsId })
    );
  },
  /**
   * 物业增加告警通知规则
   */
  addEventNotifyRegulationForProperty(
    detectRegulationId,
    targetUserId,
    notifyingBy,
    level,
    enable
  ) {
    return axios.post(
      base.event.addEventNotifyRegulationForProperty,
      utils.postParamsArrayToJsonString({
        detectRegulationId,
        targetUserId,
        notifyingBy,
        level,
        enable,
      })
    );
  },
  /**
   * 物业增加告警通知规则
   */
  addEventNotifyRegulationForProperty2(
    detectRegulationsId,
    targetUserId,
    notifyingBy,
    level,
    enable
  ) {
    return axios.post(
      base.event.addEventNotifyRegulationForProperty2,
      utils.postParamsArrayToJsonString({
        detectRegulationsId,
        targetUserId,
        notifyingBy,
        level,
        enable,
      })
    );
  },
  /**
   * 物业修改告警通知规则
   */
  modifyEventNotifyRegulationForProperty(
    id,
    targetUserId,
    notifyingBy,
    level,
    enable
  ) {
    return axios.post(
      base.event.modifyEventNotifyRegulationForProperty,
      utils.postParamsArrayToJsonString({
        id,
        targetUserId,
        notifyingBy,
        level,
        enable,
      })
    );
  },
  /**
   * 物业删除告警通知规则
   */
  deleteEventNotifyRegulationForProperty(id) {
    return axios.post(
      base.event.deleteEventNotifyRegulationForProperty,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 物业查询告警通知规则
   */
  getEventNotifyRegulationsForProperty(detectRegulationId) {
    return axios.post(
      base.event.getEventNotifyRegulationsForProperty,
      utils.postParamsArrayToJsonString({ detectRegulationId })
    );
  },
  /**
   * 物业查询告警/事件记录
   */
  getEventRecordForProperty(
    companyId,
    rentalAreasId,
    codes,
    types,
    confirmingUserId,
    handlingUserId,
    levels,
    startTime,
    endTime,
    offset,
    limit
  ) {
    return axios.post(
      base.event.getEventRecordForProperty,
      utils.postParamsArrayToJsonString({
        companyId,
        rentalAreasId,
        codes,
        types,
        confirmingUserId,
        handlingUserId,
        levels,
        startTime,
        endTime,
        offset,
        limit,
      })
    );
  },
  /**
   * 物业查询告警/事件记录
   */
  getCountOfEventRecordForProperty(
    companyId,
    rentalAreasId,
    codes,
    types,
    confirmingUserId,
    handlingUserId,
    levels,
    startTime,
    endTime
  ) {
    return axios.post(
      base.event.getCountOfEventRecordForProperty,
      utils.postParamsArrayToJsonString({
        companyId,
        rentalAreasId,
        codes,
        types,
        confirmingUserId,
        handlingUserId,
        levels,
        startTime,
        endTime,
      })
    );
  },
  /**
   * 物业处理告警/事件
   */
  handleEventForProperty(eventId, comment) {
    return axios.post(
      base.event.handleEventForProperty,
      utils.postParamsArrayToJsonString({ eventId, comment })
    );
  },
  /**
   * 物业查询告警处理表
   */
  getEventHandlingResultForProperty(eventId) {
    return axios.post(
      base.event.getEventHandlingResultForProperty,
      utils.postParamsArrayToJsonString({ eventId })
    );
  },
  /**
   * 物业确认告警/事件
   */
  confirmEventForProperty(eventIds) {
    return axios.post(
      base.event.confirmEventForProperty,
      utils.postParamsArrayToJsonString({ eventIds })
    );
  },
  /**
   * 物业查询告警处理表
   */
  getEventConfirmingResultForProperty(eventId) {
    return axios.post(
      base.event.getEventConfirmingResultForProperty,
      utils.postParamsArrayToJsonString({ eventId })
    );
  },
  /**
   * 物业查询告警计数概览
   */
  getOverviewThatCountOfEventHandlingForProperty(
    companyId,
    startTime,
    endTime
  ) {
    return axios.post(
      base.event.getOverviewThatCountOfEventHandlingForProperty,
      utils.postParamsArrayToJsonString({ companyId, startTime, endTime })
    );
  },
  /**
   * 物业获取告警数量排行
   */
  getRankingThatCountOfEventForProperty(companyId, startTime, endTime, limit) {
    return axios.post(
      base.event.getRankingThatCountOfEventForProperty,
      utils.postParamsArrayToJsonString({
        companyId,
        startTime,
        endTime,
        limit,
      })
    );
  },
  /**
   * 物业获取告警数量排行
   */
  getRankingThatCountOfEventForProperty2(measuresId, startTime, endTime) {
    return axios.post(
      base.event.getRankingThatCountOfEventForProperty2,
      utils.postParamsArrayToJsonString({ measuresId, startTime, endTime })
    );
  },
  /**
   * 公司租户增加告警探测规则
   */
  addEventDetectRegulationForCompanyLessee(
    name,
    displayName,
    rentalAreaId,
    measureId,
    code,
    type,
    mode,
    params,
    referenceTo,
    detectingByPhysicalDevice,
    enable,
    companyId
  ) {
    return axios.post(
      base.event.addEventDetectRegulationForCompanyLessee,
      utils.postParamsArrayToJsonString({
        name,
        displayName,
        rentalAreaId,
        measureId,
        code,
        type,
        mode,
        params,
        referenceTo,
        detectingByPhysicalDevice,
        enable,
        companyId,
      })
    );
  },
  /**
   * 公司租户修改告警探测规则
   */
  modifyEventDetectRegulationForCompanyLessee(
    id,
    name,
    displayName,
    type,
    mode,
    params,
    referenceTo,
    detectingByPhysicalDevice,
    enable
  ) {
    return axios.post(
      base.event.modifyEventDetectRegulationForCompanyLessee,
      utils.postParamsArrayToJsonString({
        id,
        name,
        displayName,
        type,
        mode,
        params,
        referenceTo,
        detectingByPhysicalDevice,
        enable,
      })
    );
  },
  /**
   * 公司租户删除告警探测规则
   */
  deleteEventDetectRegulationForCompanyLessee(id) {
    return axios.post(
      base.event.deleteEventDetectRegulationForCompanyLessee,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 公司租户查询告警探测规则
   */
  getEventDetectRegulationsForCompanyLessee(measureId) {
    return axios.post(
      base.event.getEventDetectRegulationsForCompanyLessee,
      utils.postParamsArrayToJsonString({ measureId })
    );
  },
  /**
   * 公司租户查询告警探测规则
   */
  getEventDetectRegulationsForCompanyLessee2(regulationsId) {
    return axios.post(
      base.event.getEventDetectRegulationsForCompanyLessee2,
      utils.postParamsArrayToJsonString({ regulationsId })
    );
  },
  /**
   * 公司租户增加告警通知规则
   */
  addEventNotifyRegulationForCompanyLessee(
    detectRegulationId,
    targetUserId,
    notifyingBy,
    level,
    enable
  ) {
    return axios.post(
      base.event.addEventNotifyRegulationForCompanyLessee,
      utils.postParamsArrayToJsonString({
        detectRegulationId,
        targetUserId,
        notifyingBy,
        level,
        enable,
      })
    );
  },
  /**
   * 公司租户增加告警通知规则
   */
  addEventNotifyRegulationForCompanyLessee2(
    detectRegulationsId,
    targetUserId,
    notifyingBy,
    level,
    enable
  ) {
    return axios.post(
      base.event.addEventNotifyRegulationForCompanyLessee2,
      utils.postParamsArrayToJsonString({
        detectRegulationsId,
        targetUserId,
        notifyingBy,
        level,
        enable,
      })
    );
  },
  /**
   * 公司租户修改告警通知规则
   */
  modifyEventNotifyRegulationForCompanyLessee(
    id,
    targetUserId,
    notifyingBy,
    level,
    enable
  ) {
    return axios.post(
      base.event.modifyEventNotifyRegulationForCompanyLessee,
      utils.postParamsArrayToJsonString({
        id,
        targetUserId,
        notifyingBy,
        level,
        enable,
      })
    );
  },
  /**
   * 公司租户删除告警通知规则
   */
  deleteEventNotifyRegulationForCompanyLessee(id) {
    return axios.post(
      base.event.deleteEventNotifyRegulationForCompanyLessee,
      utils.postParamsArrayToJsonString({ id })
    );
  },
  /**
   * 公司租户查询告警通知规则
   */
  getEventNotifyRegulationsForCompanyLessee(detectRegulationId) {
    return axios.post(
      base.event.getEventNotifyRegulationsForCompanyLessee,
      utils.postParamsArrayToJsonString({ detectRegulationId })
    );
  },
  /**
   * 公司租户查询告警/事件记录
   */
  getEventRecordForCompanyLessee(
    companyId,
    rentalAreasId,
    codes,
    types,
    confirmingUserId,
    handlingUserId,
    levels,
    startTime,
    endTime,
    offset,
    limit
  ) {
    return axios.post(
      base.event.getEventRecordForCompanyLessee,
      utils.postParamsArrayToJsonString({
        companyId,
        rentalAreasId,
        codes,
        types,
        confirmingUserId,
        handlingUserId,
        levels,
        startTime,
        endTime,
        offset,
        limit,
      })
    );
  },
  /**
   * 公司租户查询告警/事件记录
   */
  getCountOfEventRecordForCompanyLessee(
    companyId,
    rentalAreasId,
    codes,
    types,
    confirmingUserId,
    handlingUserId,
    levels,
    startTime,
    endTime
  ) {
    return axios.post(
      base.event.getCountOfEventRecordForCompanyLessee,
      utils.postParamsArrayToJsonString({
        companyId,
        rentalAreasId,
        codes,
        types,
        confirmingUserId,
        handlingUserId,
        levels,
        startTime,
        endTime,
      })
    );
  },
  /**
   * 公司租户处理告警/事件
   */
  handleEventForCompanyLessee(eventId, comment) {
    return axios.post(
      base.event.handleEventForCompanyLessee,
      utils.postParamsArrayToJsonString({ eventId, comment })
    );
  },
  /**
   * 公司租户查询告警处理表
   */
  getEventHandlingResultForCompanyLessee(eventId) {
    return axios.post(
      base.event.getEventHandlingResultForCompanyLessee,
      utils.postParamsArrayToJsonString({ eventId })
    );
  },
  /**
   * 公司租户确认告警/事件
   */
  confirmEventForCompanyLessee(eventIds) {
    return axios.post(
      base.event.confirmEventForCompanyLessee,
      utils.postParamsArrayToJsonString({ eventIds })
    );
  },
  /**
   * 公司租户查询告警处理表
   */
  getEventConfirmingResultForCompanyLessee(eventId) {
    return axios.post(
      base.event.getEventConfirmingResultForCompanyLessee,
      utils.postParamsArrayToJsonString({ eventId })
    );
  },
  /**
   * 公司租户查询告警计数概览
   */
  getOverviewThatCountOfEventHandlingForCompanyLessee(
    companyId,
    startTime,
    endTime
  ) {
    return axios.post(
      base.event.getOverviewThatCountOfEventHandlingForCompanyLessee,
      utils.postParamsArrayToJsonString({ companyId, startTime, endTime })
    );
  },
  /**
   * 公司租户获取告警数量排行
   */
  getRankingThatCountOfEventForCompanyLessee(
    companyId,
    startTime,
    endTime,
    limit
  ) {
    return axios.post(
      base.event.getRankingThatCountOfEventForCompanyLessee,
      utils.postParamsArrayToJsonString({
        companyId,
        startTime,
        endTime,
        limit,
      })
    );
  },
  /**
   * 公司租户获取告警数量排行
   */
  getRankingThatCountOfEventForCompanyLessee2(measuresId, startTime, endTime) {
    return axios.post(
      base.event.getRankingThatCountOfEventForCompanyLessee2,
      utils.postParamsArrayToJsonString({ measuresId, startTime, endTime })
    );
  },
  /**
   * 个人租户增加告警探测规则
   */
  addEventDetectRegulationForPersonalLessee(
    name,
    displayName,
    rentalAreaId,
    measureId,
    code,
    type,
    mode,
    params,
    referenceTo,
    detectingByPhysicalDevice,
    enable
  ) {
    return axios.post(
      base.event.addEventDetectRegulationForPersonalLessee,
      utils.postParamsArrayToJsonString({
        name,
        displayName,
        rentalAreaId,
        measureId,
        code,
        type,
        mode,
        params,
        referenceTo,
        detectingByPhysicalDevice,
        enable,
      })
    );
  },
  /**
   * 个人租户修改告警探测规则
   */
  modifyEventDetectRegulationForPersonalLessee(
    id,
    name,
    displayName,
    type,
    mode,
    params,
    referenceTo,
    detectingByPhysicalDevice,
    enable
  ) {
    return axios.post(
      base.event.modifyEventDetectRegulationForPersonalLessee,
      utils.postParamsArrayToJsonString({
        id,
        name,
        displayName,
        type,
        mode,
        params,
        referenceTo,
        detectingByPhysicalDevice,
        enable,
      })
    );
  },

  /**
   * 个人租户删除告警探测规则
   */
  deleteEventDetectRegulationForPersonalLessee(id) {
    return axios.post(
      base.event.deleteEventDetectRegulationForPersonalLessee,
      utils.postParamsArrayToJsonString({ id })
    );
  }, //
  /**
   * 个人租户查询告警探测规则
   */
  getEventDetectRegulationsForPersonalLessee(measureId) {
    return axios.post(
      base.event.getEventDetectRegulationsForPersonalLessee,
      utils.postParamsArrayToJsonString({ measureId })
    );
  }, //
  /**
   * 个人租户查询告警探测规则
   */
  getEventDetectRegulationsForPersonalLessee2(regulationsId) {
    return axios.post(
      base.event.getEventDetectRegulationsForPersonalLessee2,
      utils.postParamsArrayToJsonString({ regulationsId })
    );
  }, //
  /**
   * 个人租户增加告警通知规则
   */
  addEventNotifyRegulationForPersonalLessee(
    detectRegulationId,
    notifyingBy,
    level,
    enable
  ) {
    return axios.post(
      base.event.addEventNotifyRegulationForPersonalLessee,
      utils.postParamsArrayToJsonString({
        detectRegulationId,
        notifyingBy,
        level,
        enable,
      })
    );
  }, //
  /**
   * 个人租户增加告警通知规则
   */
  addEventNotifyRegulationForPersonalLessee2(
    detectRegulationsId,
    notifyingBy,
    level,
    enable
  ) {
    return axios.post(
      base.event.addEventNotifyRegulationForPersonalLessee2,
      utils.postParamsArrayToJsonString({
        detectRegulationsId,
        notifyingBy,
        level,
        enable,
      })
    );
  }, //
  /**
   * 个人租户修改告警通知规则
   */
  modifyEventNotifyRegulationForPersonalLessee(id, notifyingBy, level, enable) {
    return axios.post(
      base.event.modifyEventNotifyRegulationForPersonalLessee,
      utils.postParamsArrayToJsonString({ id, notifyingBy, level, enable })
    );
  }, //
  /**
   * 个人租户删除告警通知规则
   */
  deleteEventNotifyRegulationForPersonalLessee(id) {
    return axios.post(
      base.event.deleteEventNotifyRegulationForPersonalLessee,
      utils.postParamsArrayToJsonString({ id })
    );
  }, //
  /**
   * 个人租户查询告警通知规则
   */
  getEventNotifyRegulationsForPersonalLessee(detectRegulationId) {
    return axios.post(
      base.event.getEventNotifyRegulationsForPersonalLessee,
      utils.postParamsArrayToJsonString({ detectRegulationId })
    );
  }, //
  /**
   * 个人租户查询告警/事件记录
   */
  getEventRecordForPersonalLessee(
    rentalAreasId,
    codes,
    types,
    confirmingUserId,
    handlingUserId,
    levels,
    startTime,
    endTime,
    offset,
    limit
  ) {
    return axios.post(
      base.event.getEventRecordForPersonalLessee,
      utils.postParamsArrayToJsonString({
        rentalAreasId,
        codes,
        types,
        confirmingUserId,
        handlingUserId,
        levels,
        startTime,
        endTime,
        offset,
        limit,
      })
    );
  }, //
  /**
   * 个人租户查询告警/事件记录
   */
  getCountOfEventRecordForPersonalLessee(
    rentalAreasId,
    codes,
    types,
    confirmingUserId,
    handlingUserId,
    levels,
    startTime,
    endTime
  ) {
    return axios.post(
      base.event.getCountOfEventRecordForPersonalLessee,
      utils.postParamsArrayToJsonString({
        rentalAreasId,
        codes,
        types,
        confirmingUserId,
        handlingUserId,
        levels,
        startTime,
        endTime,
      })
    );
  }, //
  /**
   * 个人租户处理告警/事件
   */
  handleEventForPersonalLessee(eventId, comment) {
    return axios.post(
      base.event.handleEventForPersonalLessee,
      utils.postParamsArrayToJsonString({ eventId, comment })
    );
  }, //
  /**
   * 个人租户查询告警处理表
   */
  getEventHandlingResultForPersonalLessee(eventId) {
    return axios.post(
      base.event.getEventHandlingResultForPersonalLessee,
      utils.postParamsArrayToJsonString({ eventId })
    );
  }, //
  /**
   * 个人租户确认告警/事件
   */
  confirmEventForPersonalLessee(eventIds) {
    return axios.post(
      base.event.confirmEventForPersonalLessee,
      utils.postParamsArrayToJsonString({ eventIds })
    );
  }, //
  /**
   * 个人租户查询告警处理表
   */
  getEventConfirmingResultForPersonalLessee(eventId) {
    return axios.post(
      base.event.getEventConfirmingResultForPersonalLessee,
      utils.postParamsArrayToJsonString({ eventId })
    );
  }, //
  /**
   * 个人租户查询告警计数概览
   */
  getOverviewThatCountOfEventHandlingForPersonalLessee(startTime, endTime) {
    return axios.post(
      base.event.getOverviewThatCountOfEventHandlingForPersonalLessee,
      utils.postParamsArrayToJsonString({ startTime, endTime })
    );
  }, //
  /**
   * 个人租户获取告警数量排行
   */
  getRankingThatCountOfEventForPersonalLessee(startTime, endTime, limit) {
    return axios.post(
      base.event.getRankingThatCountOfEventForPersonalLessee,
      utils.postParamsArrayToJsonString({ startTime, endTime, limit })
    );
  }, //
  /**
   * 个人租户获取告警数量排行
   */
  getRankingThatCountOfEventForPersonalLessee2(measuresId, startTime, endTime) {
    return axios.post(
      base.event.getRankingThatCountOfEventForPersonalLessee2,
      utils.postParamsArrayToJsonString({ measuresId, startTime, endTime })
    );
  }, //

  /**
   * 获取告警处理/确认状态分等级计数
   */
  getCountOfEventStatusGroupByLevel(companyId, startTime, endTime) {
    return axios.post(
      base.event.getCountOfEventStatusGroupByLevel,
      utils.postParamsArrayToJsonString({ companyId, startTime, endTime })
    );
  },
  /**
   * 获取告警处理/确认状态分类计数
   */
  getCountOfEventGroupByType(companyId, startTime, endTime) {
    return axios.post(
      base.event.getCountOfEventGroupByType,
      utils.postParamsArrayToJsonString({ companyId, startTime, endTime })
    );
  },
  /**
   * 物业获取告警处理/确认状态分等级计数
   */
  getCountOfEventStatusGroupByLevelForProperty(companyId, startTime, endTime) {
    return axios.post(
      base.event.getCountOfEventStatusGroupByLevelForProperty,
      utils.postParamsArrayToJsonString({ companyId, startTime, endTime })
    );
  },
  /**
   * 物业获取告警处理/确认状态分类计数
   */
  getCountOfEventGroupByTypeForProperty(companyId, startTime, endTime) {
    return axios.post(
      base.event.getCountOfEventGroupByTypeForProperty,
      utils.postParamsArrayToJsonString({ companyId, startTime, endTime })
    );
  },
  /**
   * 公司租户获取告警处理/确认状态分等级计数
   */
  getCountOfEventStatusGroupByLevelForCompanyLessee(
    companyId,
    startTime,
    endTime
  ) {
    return axios.post(
      base.event.getCountOfEventStatusGroupByLevelForCompanyLessee,
      utils.postParamsArrayToJsonString({ companyId, startTime, endTime })
    );
  },
  /**
   * 公司租户获取告警处理/确认状态分类计数
   */
  getCountOfEventGroupByTypeForCompanyLessee(companyId, startTime, endTime) {
    return axios.post(
      base.event.getCountOfEventGroupByTypeForCompanyLessee,
      utils.postParamsArrayToJsonString({ companyId, startTime, endTime })
    );
  },
  /**
   * 获取告警处理/确认状态分等级计数
   */
  getCountOfEventStatusGroupByLevelForPersonalLessee(startTime, endTime) {
    return axios.post(
      base.event.getCountOfEventStatusGroupByLevelForPersonalLessee,
      utils.postParamsArrayToJsonString({ startTime, endTime })
    );
  },
  /**
   * 获取告警处理/确认状态分类计数
   */
  getCountOfEventGroupByTypeForPersonalLessee(startTime, endTime) {
    return axios.post(
      base.event.getCountOfEventGroupByTypeForPersonalLessee,
      utils.postParamsArrayToJsonString({ startTime, endTime })
    );
  },
  /**
   * 个人设置告警通知等级重命名
   */
  setPersonalEventNotifyLevelRedefines(names) {
    return axios.post(
      base.event.setPersonalEventNotifyLevelRedefines,
      utils.postParamsArrayToJsonString({ names })
    );
  },
  /**
   * 个人查询告警通知等级重命名
   */
  getPersonalEventNotifyLevelRedefines() {
    return axios.post(
      base.event.getPersonalEventNotifyLevelRedefines,
      utils.postParamsArrayToJsonString({})
    );
  },

  getCountOfEventGroupByCode(companyId, startTime, endTime) {
    return axios.post(
      base.event.getCountOfEventGroupByCode,
      utils.postParamsArrayToJsonString({ companyId, startTime, endTime })
    );
  },
  getCountOfEventGroupByCodeForProperty(companyId, startTime, endTime) {
    return axios.post(
      base.event.getCountOfEventGroupByCodeForProperty,
      utils.postParamsArrayToJsonString({ companyId, startTime, endTime })
    );
  },
  getCountOfEventGroupByCodeForCompanyLessee(companyId, startTime, endTime) {
    return axios.post(
      base.event.getCountOfEventGroupByCodeForCompanyLessee,
      utils.postParamsArrayToJsonString({ companyId, startTime, endTime })
    );
  },
  getCountOfEventGroupByCodeForPersonalLessee(startTime, endTime) {
    return axios.post(
      base.event.getCountOfEventGroupByCodeForPersonalLessee,
      utils.postParamsArrayToJsonString({ startTime, endTime })
    );
  },
  modifyEventDetectRegulationEnable(enable, measuresId) {
    return axios.post(
      base.event.modifyEventDetectRegulationEnable,
      utils.postParamsArrayToJsonString({ enable, measuresId })
    );
  },
  modifyEventNotifyRegulationEnable(enable, measuresId) {
    return axios.post(
      base.event.modifyEventNotifyRegulationEnable,
      utils.postParamsArrayToJsonString({ enable, measuresId })
    );
  },
};

export default event;
